export default __webpack_public_path__ + "static/media/Al-Lami.fbe2f59a.png";